import { XcoreConfigRawValue } from "./../config";
import { ConfigError } from "./errors";

/**
 * @throws {ConfigError}
 */
export const readXcoreConfig = async (): Promise<XcoreConfigRawValue> => {
  // Needs to be imported here otherwise webpack throws error that client is trying to access server fs
  const fs = await import("fs");

  return await fs.promises
    .readFile(await getXcoreConfigPath())
    .then((buffer) => buffer.toString())
    .then(JSON.parse)
    .catch((e) => {
      throw invalidConfigError(e);
    });
};

/**
 * @throws {ConfigError}
 */
export const getXcoreConfigPath = async () => {
  // Needs to be imported here otherwise webpack throws error that client is trying to access server fs
  const [fs, path] = await Promise.all([await import("fs"), await import("path")]);

  let configPath: string | null = null;
  for (const p of listXcoreConfigPaths(path.resolve)) {
    configPath ??= await fs.promises
      .access(p)
      .then(() => p)
      .catch(() => null);
  }

  if (!configPath) {
    throw configNotFoundError();
  }

  return configPath;
};

export const readXcoreConfigSync = (): XcoreConfigRawValue => {
  const fs = require("fs");

  return JSON.parse(fs.readFileSync(getXcoreConfigPathSync()).toString());
};

/**
 * @throws {ConfigError}
 */
export const getXcoreConfigPathSync = () => {
  const path = require("path");
  const fs = require("fs");

  const xcoreConfigPaths = listXcoreConfigPaths(path.resolve);

  let configPath: string | null = null;
  for (const p of xcoreConfigPaths) {
    if (fs.existsSync(p)) {
      configPath = p;
      break;
    }
  }

  if (!configPath) {
    throw configNotFoundError();
  }

  return configPath;
};

const listXcoreConfigPaths = (join: (..._: string[]) => string) => [
  join(process.cwd(), "xcore.config.json"),
  join(process.cwd(), "..", "xcore.config.json"),
];

const configNotFoundError = () => new ConfigError(`Unable to access config file at ${process.cwd()}. Maybe wrong XCORE_ENV?`);

const invalidConfigError = (e: unknown) =>
  new ConfigError("Invalid config: can't read & parse the config file." + (e instanceof Error ? "Reason: " + e.message : ""));
